import type { OrganisationWithMembers } from "~/types/organisations/types";

export default function useOrganisationsDatabase() {
  const posthog = usePosthog();
  const userStore = useUserStore();

  async function fetchUsersOrganisations(): Promise<OrganisationWithMembers[]> {
    const userId = userStore.user?.id;

    if (!userId) return [];

    try {
      const { data, error } = await usePrivateApiFetch()<{
        data?: OrganisationWithMembers[] | null;
        error?: unknown;
      }>("/api/organisations", {
        method: HttpMethod.GET,
        query: {
          user_id: userId,
        },
      });

      if (error) throw error;

      return data ?? [];
    } catch (error) {
      posthog.logError(error, "useOrganisationsDatabase:fetchUsersOrganisations");
      throw error;
    }
  }

  return {
    fetchUsersOrganisations,
  };
}
